@defer (on viewport) {
<py-cutting-modal></py-cutting-modal>
} @placeholder {
<div></div>
}
